import request from "@/utils/request";

// 列表(主数据列表)
export function loadAppUserScanAbnormalLockListDataApi(data) {
  return request({
    url: "web/appUserScanAbnormalLock/listData",
    method: "post",
    data
  });
}

// 导出(主数据列表)
export function loadAppUserScanAbnormalLockExportDataApi(data) {
  return request({
    url: "web/appUserScanAbnormalLock/exportData",
    method: "post",
    data
  });
}
// 初始化
export function initAppUserScanAbnormalLockApi(data) {
    return request({
        url: "web/appUserScanAbnormalLock/init",
        method: "post",
        data
    });
}
  
// 操作
export function saveOrUpdateAppUserScanAbnormalLockApi(data) {
    return request({
        url: "web/appUserScanAbnormalLock/saveOrUpdate",
        method: "post",
        data
    });
}